module.exports = __webpack_public_path__ + "static/media/X.e9ffe875.svg";